<div class="email-receipt-resend">
  <div class="email-receipt-header flex-between-center width-100p p-3">
    <p class="m-0 font-bold">Payment Details</p>
    <i class="fal fa-times close-icon" (click)="closeDialog()"></i>
  </div>

  <div class="email-receipt-resend-body p-3">
    <div class="check-wrapper">
      <div class="icon">
        <i class="fal fa-money-check-alt"></i>
      </div>

      <div class="type" tooltipPosition="left"
        tooltipStyleClass="ticket-tooltip modifier payment-hostory-size completed" [escape]="false"
        [pTooltip]="payment.tooltip">
        <div class="payment-type">
          <span *ngIf="payment.paymentType === 'cash'">
            Cash
          </span>

          <span *ngIf="payment.paymentType === 'cheque'">
            {{this.dataService.checkTxt}} {{payment.checkNo}}
          </span>

          <span *ngIf="payment.paymentType === 'card'">
            Card {{payment.cardType}} {{payment.card4Digits}}
          </span>

          <span *ngIf="payment.paymentType === 'thirdParty'">
            3rd Party - {{payment?.paymentMethod?.name}}
          </span>
        </div>

        <div class="payment-date">
          {{payment?.createdAt}}
        </div>
      </div>

      <div class="amount">
        {{payment?.amount - (payment?.refundToDate || 0) | currency: usd}}
      </div>
    </div>

    <div class="mt-2 ro-restricted-msg" *ngIf="isOrderRestricted">
      <span class="font-12">
        <i class="fal fa-lock pr-1"></i>
        This RO is currently being updated by {{restriction?.employeeFirstName}} {{restriction?.employeeLastName}}.
      </span>
    </div>

    <div class="option-button-wrapper">
      <div class="option-wrapper pointer" (click)="optionHandler('email')"
        [ngClass]="{'disabled-estimate-field not-allowed': isArchived || isOrderRestricted || isLoading}">
        <div class="icon">
          <i class="fal fa-envelope"></i>
        </div>
        Send Receipt
      </div>

      <div class="option-wrapper ml-15 pointer" (click)="optionHandler('print')"
        [ngClass]="{'disabled-estimate-field not-allowed': isArchived || isOrderRestricted || isLoading}">
        <div class="icon">
          <i class="fal fa-print"></i>
        </div>
        {{payment?.isPdfUploaded? 'Download': 'View'}} Receipt
      </div>

      <div class="option-wrapper ml-15 pointer" (click)="optionHandler('edit')"
        [ngClass]="{'disabled-estimate-field not-allowed': isArchived || isOrderRestricted || isLoading || payment?.paymentType === 'writeOff'}">
        <div class="icon">
          <i class="fal fa-pencil"></i>
        </div>
        Edit
      </div>
    </div>
  </div>

  <div class="email-receipt-footer flex-between-center width-100p pt-2 pb-2 pl-3 pr-3">
    <span class="font-primary font-600 font-12 pointer">
      <span>&nbsp;&nbsp;</span>
    </span>
    <button class="btn btn-save font-12 pointer" (click)="closeDialog()">Close</button>
  </div>
</div>
